const state = {
    selectedArticle: null,//stores the selected client(used in form modal)
    articleShow: false, //show=true | edit=false
    formArticle: null,
    showArticleModal: false,//controls if the form modal is displayed or not
};

const getters = {
    getSelectedArticle(state, getters){
        if(!state.selectedArticle){
            state.selectedArticle = getters.getNewArticle;
        }
        return state.selectedArticle;
    },
    getFormArticle(state, getters){
        if(!state.formArticle){
            state.formArticle = getters.getEmptyFormArticle;
        }
        return state.formArticle;
    },
    getArticleShow(state){
        return state.articleShow;
    },
    getShowArticleModal(state){
        return state.showArticleModal;
    },

    getNewArticle(){
        return {
            id: '',
            code: '',
            name: '',
            companies_id: '',
            types_id: '',
            bar_code: '',
            price: '',
            unity: '',
            active_state: '',
            stock: '',
            min_stock: '',
            category: '',
            subcategory: '',
            description: '',
            article_type_name: '',
            created_at: '',
        };
    },

    getEmptyFormArticle(){
        return {
            id: '',
            name: '',
            types_id: '',
            bar_code: '',
            price: '',
            unity: '',
            active_state: '',
            stock: '',
            min_stock: '',
            category: '',
            subcategory: '',
            companies_id: '',
            description: '',
        }
    }
};

const mutations = {
    setSelectedArticle(state, payload){ //this also works for new article
        state.selectedArticle = payload;
    },
    setFormUser(state, payload){ //this also works for new article
        state.formUser = payload;
    },
    setPreparedFormArticle(state, payload){
        state.formArticle = {
            id: payload ? payload.id : '',
            name: payload ? payload.name : '',
            types_id: payload ? payload.types_id : '',
            bar_code: payload ? payload.bar_code : '',
            price: payload ? payload.price : '',
            unity: payload ? payload.unity : '',
            active_state: payload ? payload.active_state : '',
            stock: payload ? payload.stock : '',
            min_stock: payload ? payload.min_stock : 0,
            category: payload ? payload.category_id : 0,
            subcategory: payload ? payload.subcategory_id : 0,
            companies_id: payload ? payload.companies_id : '',
            description: payload ? payload.description : '',
        };
    },
    setArticleShow(state, payload){ //this also works for new article
        state.articleShow = payload;
    },
    setShowArticleModal(state, payload){
        state.showArticleModal = payload;
    },
};

const actions = {
    setSelectedArticle({commit}, payload){
        commit('setSelectedArticle', payload);
        commit('setPreparedFormArticle', payload);
    },
    setArticleShow({commit}, payload){
        commit('setArticleShow', payload);
    },
    setShowArticleModal({commit}, payload){
        commit('setShowArticleModal', payload);
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};

